import { render, staticRenderFns } from "./HappyTable43Inch.vue?vue&type=template&id=fe39d6e6&scoped=true"
import script from "./HappyTable43Inch.vue?vue&type=script&lang=js"
export * from "./HappyTable43Inch.vue?vue&type=script&lang=js"
import style0 from "./HappyTable43Inch.vue?vue&type=style&index=0&id=fe39d6e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe39d6e6",
  null
  
)

export default component.exports